// @ts-nocheck

class KlaviyoNotificationsClass {
  constructor() {
    const id =
      Date.now().toString(36) + Math.random().toString(36).substring(2);
    this.setProfile = function (
      external_id,
      email,
      first_name = '',
      last_name = '',
      phone_number = '',
      klaviyo_set_profile_callback,
    ) {
      window.natively.trigger(
        id,
        0,
        klaviyo_set_profile_callback, // (response: {status: string}) => void
        'klaviyo_set_profile',
        {
          external_id,
          email,
          first_name,
          last_name,
          phone_number,
        },
      );
    };
    this.resetProfile = function () {
      window.natively.trigger(id, 0, undefined, 'klaviyo_reset_profile');
    };
    this.getExternalId = function (
      get_external_id_callback, // (response: {external_id: string}) => void
    ) {
      window.natively.trigger(
        id,
        0,
        get_external_id_callback,
        'klaviyo_external_id',
      );
    };
    this.requestPermission = function (
      push_register_callback, // (response: {status: string}) => void
    ) {
      window.natively.trigger(
        id,
        0,
        push_register_callback,
        'klaviyo_push_register',
      );
    };
    this.getPermissionStatus = function (
      push_permission_callback, // (response: {status: bool, token: string}) => void
    ) {
      window.natively.trigger(
        id,
        0,
        push_permission_callback,
        'klaviyo_push_permission',
      );
    };
  }
}

const __instance = new KlaviyoNotificationsClass();

export function loadKlaviyoNotification(userData: any) {
  console.log(userData);

  if (!userData || !window.natively) {
    // skip when no user is login
    return;
  }

  window.natively.setDebug(true);

  // initiate klaviyo notification
  initKlaviyo(function () {
    __instance.setProfile(
      userData.id,
      userData.email,
      '',
      '',
      '',
      function (res) {
        console.log({ step: '4 - setProfile', res });
        __instance.getPermissionStatus(function (res) {
          console.log({
            step: '5 - getPermissionStatus - debug permission',
            res,
          });
          //   window.natively.openLogger();
        });
      },
    );
  });

  // it will try to initiate klaviyo notification for 2x
  function initKlaviyo(callback, retryCount) {
    if (!retryCount) {
      retryCount = 0;
    }
    if (retryCount && retryCount > 4) {
      console.error('unable to get notification permission');
      return;
    }

    __instance.getPermissionStatus(function (res) {
      console.log({ step: '1 - getPermissionStatus', res });
      if (res.status) {
        callback();
        return;
      }

      __instance.requestPermission(function (res) {
        console.log({ step: '2 - requestPermission', res });
        if (res.status) {
          callback();
        }
      });
    });
  }
}
